import React from 'react';
import {
    IonItem,
    IonLabel,
    IonSkeletonText,
} from '@ionic/react';

interface SkeletonLoadingProps {
  isLoading: boolean,
}

const SkeletonLoadingIonList: React.FC <SkeletonLoadingProps> = ({ isLoading }) => {
    return (
      <div className={isLoading ? '' : 'hidden'}>
        {
          [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19].map(item =>
            <IonItem key={item} className="custom-skeleton">
              <IonLabel>
                <h3>
                  <IonSkeletonText animated style={{ width: '50%' }} />
                </h3>
                <p>
                  <IonSkeletonText animated style={{ width: '80%' }} />
                </p>
              </IonLabel>
            </IonItem>
          )
        }
      </div>
    )
}

export default SkeletonLoadingIonList;